//Doulbe unit on mobile move button bellow image
const doubleUnitSections = document.querySelectorAll(".blocks_two_section");

doubleUnitSections.forEach((doubleUnit) => {
  const btn = doubleUnit.querySelector(".c-double-unit__txt a");
  const imgWrapper = doubleUnit.querySelector(".c-double-unit__img");
  btn.classList.add("c-btn--desktop");

  const mobileBtn = btn.cloneNode(true);
  mobileBtn.classList.add("c-btn--mobile");

  imgWrapper.appendChild(mobileBtn);
});
